<script>
    import Button from "../windows/Button.svelte";
    import windows from "../../stores/windows.js";
    import { feedback as sendFeedback } from "../../api/api.js";
    import t from "../../localization/t.js";

    export let window;

    let textarea;
    let contactInput;
    let isEnabled = true;

    $: textarea && textarea.focus();

    function didClickSubmitButton() {
        if (textarea.value.length === 0) {
            textarea.focus();
            return;
        }

        isEnabled = false;

        sendFeedback(`${textarea.value} (${contactInput.value})`);

        setTimeout(() => {
            windows.close(window.id);
        }, 1000);
    }
</script>

<div class="report">
    <textarea
        disabled={!isEnabled}
        bind:this={textarea}
        placeholder={t("feedback.message")}
    />
    <input
        disabled={!isEnabled}
        type="text"
        placeholder={t("feedback.contact_info")}
        bind:this={contactInput}
    />
    <div class="controls">
        <Button {isEnabled} action={didClickSubmitButton}>
            {isEnabled ? t("feedback.send") : t("feedback.sending")}
        </Button>
        <div class="flexible" />
    </div>
</div>

<style>
    .report {
        display: flex;
        flex-direction: column;
        gap: var(--spacing);
        box-sizing: border-box;
        padding: var(--spacing);
        height: 100%;
    }

    textarea {
        flex-grow: 1;
        appearance: none;
        box-sizing: border-box;
        margin: 0;
        outline: none;
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        border-radius: 0;
        padding: var(--spacing);
        resize: none;
        font-size: inherit;
        user-select: text;
        -webkit-user-select: text;
    }

    @media only screen and (max-width: 734px) {
        textarea {
            font-size: 16px;
        }
    }

    input {
        appearance: none;
        box-sizing: border-box;
        margin: 0;
        outline: none;
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
        border-radius: 0;
        padding: var(--spacing);
        font-size: inherit;
        user-select: text;
        -webkit-user-select: text;
    }

    @media only screen and (max-width: 734px) {
        input {
            font-size: 16px;
        }
    }

    .controls {
        display: flex;
        align-items: center;
    }

    .flexible {
        flex-grow: 1;
    }
</style>
